<!--suppress CheckEmptyScriptTag -->
<template>
  <!--modal-->
  <div
    id="best-form-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div ref="modal" class="modal-dialog large-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 id="exampleModalLongTitle" class="modal-title">
            {{ $t("Price request") }}
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true"> &times; </span>
          </button>
        </div>
        <div class="modal-body">
          <div v-for="row in fields" class="row">
            <div
              v-for="field in row.items"
              :class="'col-md-' + cols / row.items.length"
            >
              <form-field :field="field"></form-field>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            {{ $t("Cancel") }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            :class="{ disabled: disabled }"
            @click="onSubmit"
          >
            {{ $t("Submit") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormField from "./fields/FormField.vue";
import Swal from "sweetalert2";

export default {
  name: "FormModal",

  components: {
    FormField,
  },
  props: ["fields", "model"],

  data() {
    return {
      cols: 12,
      disabled: false,
    };
  },

  mounted() {
    $("#best-form-modal").on("shown.bs.modal", this.onModalShown);
  },

  methods: {
    show() {
      $("#best-form-modal").modal({
        show: true,
      });
    },

    hide() {
      $("#best-form-modal").modal("hide");
    },

    onModalShown() {},

    onSubmit() {
      if (this.disabled) return;

      let fd = new FormData();
      fd.append("category_id", this.$route.params.id);
      fd.append("filter_query", JSON.stringify(this.model));

      for (var row in this.fields) {
        if (this.fields[row].items.length === 0) continue;

        for (var i in this.fields[row].items) {
          let item = this.fields[row].items[i];

          if (item.type === "file") {
            fd.append(item.id, item.file);
            continue;
          }

          fd.append(item.id, item.value);
        }
      }

      this.$http
        .post("/price-requests", fd)
        .then(() => {
          this.$toast.success(
            "Your request successfully pushed for moderating"
          );
          this.disabled = true;
          this.hide();
        })
        .catch((error) => {
          Swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            title: error.response.data.message,
            type: "error",
            timer: 5000,
          });
        });
    },
  },
};
</script>

<style scoped>
.wrapper {
  position: static;
}

@media (min-width: 992px) {
  .large-dialog {
    max-width: 650px;
  }
}
</style>
